import React from "react";
import { shallowEqual, useSelector } from "react-redux";

import { VisibilityRootState } from "../../store/VisibilityStore";
import { VisibilityAlarms } from "../VisibilityAlarms";
import { VisibilityMap } from "../VisibilityMap";

import classes from "./AlarmOrMap.module.scss";

export const AlarmOrMap = (): JSX.Element => {
	const device = useSelector((state: VisibilityRootState) => state.Visibility.device, shallowEqual);
	const multiplePlaceComponent = useSelector((state: VisibilityRootState) => state.Visibility.multiplePlaceComponent, shallowEqual);

	return (
		<>
			{!!device && multiplePlaceComponent !== "alarms" && (<div className={classes.item}><VisibilityMap className={classes.map} /></div>)}
			{!!device && multiplePlaceComponent === "alarms" && (<div className={classes.item}><VisibilityAlarms /></div>)}
		</>
	);
};
